/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Modified_UtcInputs */

const en_tables_custom_properties_modified_utc = /** @type {(inputs: Tables_Custom_Properties_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Modified UTC`)
};

const de_tables_custom_properties_modified_utc = /** @type {(inputs: Tables_Custom_Properties_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert UTC`)
};

/**
* | output |
* | --- |
* | "Properties Modified UTC" |
*
* @param {Tables_Custom_Properties_Modified_UtcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_modified_utc = /** @type {((inputs?: Tables_Custom_Properties_Modified_UtcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Modified_UtcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_modified_utc(inputs)
	return de_tables_custom_properties_modified_utc(inputs)
});